/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartTelehealthRecordsAliases {
  AVATAR_TELEHEALTH_RECORDS = 'avatar-telehealth-records',
  CARD_CONTAINER_BODY_TELEHEALTH = 'card-container-body-telehealth',
  CARD_CONTAINER_TELEHEALTH = 'card-container-telehealth',
  CARD_CONTAINER_ZONE_AVATAR_TELEHEALTH_RECORDS = 'card-container-zone-avatar-telehealth-records',
  CARD_ZONE_TELEHEALTH_RECORDS_LINK_VIEW = 'card-zone-telehealth-records-link-view',
  CARD_ZONE_TELEHEALTH_RECORDS_REGISTRY_TYPE = 'card-zone-telehealth-records-registry-type',
  CONTEXTUAL_BAR_TELEHEALTH_RECORDS = 'contextual-bar-telehealth-records',
  DECK_ITEMS_RECORDS = 'deck-items-records',
  FETCH_TELEHEALTH_INFO = 'fetch-telehealth-info',
  LINK_TELEHEALTH_RECORDS = 'link-telehealth-records',
  MAPPER_REGISTRY_TYPE = 'mapper-registry-type',
  MAPPER_TELEHEALTH_RECORDS = 'mapper-telehealth-records',
  MY_CHART_TELEHEALTH_RECORDS = 'my-chart-telehealth-records',
  PANEL_RECORDS = 'panel-records',
  TEXT_REGISTRY_TYPE = 'text-registry-type',
}
export { MyChartTelehealthRecordsAliases };
